// src/services/employeeService.js
import { apiService } from './api';

export const employeeService = {
  // Récupérer tous les employés de l'entreprise
  async getEmployees() {
    const response = await apiService.get('/employees/supadmin');
    return response.data;
  },

  // Créer un nouvel employé
  async createEmployee(employeeData) {
    const response = await apiService.post('/employees/supadmin', employeeData);
    return response.data;
  },

  // Récupérer un employé spécifique
  async getEmployee(id) { // NON UTILISé
    const response = await apiService.get(`/employees/supadmin/${id}`);
    return response.data;
  },

  // Mettre à jour un employé
  async updateEmployee(id, employeeData) {
    console.log('Updating employee with ID:', id, 'Data:', employeeData);
    const response = await apiService.put(`/employees/supadmin/${id}`, employeeData);
    return response.data;
  },

  // Supprimer un employé
  async deleteEmployee(id) {
    const response = await apiService.delete(`/employees/supadmin/${id}`);
    return response;
  },
  async resetPassword(id) {
    const response = await apiService.put(`/employees/supadmin/${id}/reset-password`);
    return response.data;
  }
};